import React from 'react';
import { BaseConfigProps } from '../shared/ConfigFormHelpers';

const GetContactPersonsConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  const config = node.data.config || {};
  const onlyWithEmail = config?.onlyWithEmail || false;
  const onlyPrimary = config?.onlyPrimary || false;
  const includeInactive = config?.includeInactive || false;

  const handleChange = (field: string, value: any) => {
    updateConfig(field, value);
  };

  return (
    <div className="space-y-4">
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-2">
          📥 Bemenet (Input)
        </h4>
        <div className="space-y-1">
          <div className="flex items-start space-x-2">
            <span className="text-xs font-mono bg-white dark:bg-gray-800 px-2 py-0.5 rounded border border-blue-200 dark:border-blue-700">customers</span>
            <span className="text-xs text-blue-700 dark:text-blue-300">✨ Ügyfelek array - Minden ügyfélhez lekérdezi a kapcsolattartókat</span>
          </div>
          <div className="flex items-start space-x-2">
            <span className="text-xs font-mono bg-white dark:bg-gray-800 px-2 py-0.5 rounded border border-blue-200 dark:border-blue-700">customer</span>
            <span className="text-xs text-blue-700 dark:text-blue-300">Egy ügyfél objektum (ID vagy teljes objektum)</span>
          </div>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
          Szűrési opciók
        </label>
        
        <div className="space-y-2">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="onlyWithEmail"
              checked={onlyWithEmail}
              onChange={(e) => handleChange('onlyWithEmail', e.target.checked)}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label htmlFor="onlyWithEmail" className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
              Csak email címmel rendelkezők
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="onlyPrimary"
              checked={onlyPrimary}
              onChange={(e) => handleChange('onlyPrimary', e.target.checked)}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label htmlFor="onlyPrimary" className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
              Csak elsődleges kapcsolattartó
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="includeInactive"
              checked={includeInactive}
              onChange={(e) => handleChange('includeInactive', e.target.checked)}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label htmlFor="includeInactive" className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
              Inaktív kapcsolattartók is
            </label>
          </div>
        </div>
      </div>

      <div className="bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-indigo-900 dark:text-indigo-100 mb-2">
          📤 Kimenet (Output)
        </h4>
        <div className="space-y-2">
          <div className="flex items-start space-x-2">
            <span className="text-xs font-mono bg-white dark:bg-gray-800 px-2 py-0.5 rounded border border-indigo-200 dark:border-indigo-700">contacts</span>
            <span className="text-xs text-indigo-700 dark:text-indigo-300">Array - Kapcsolattartók listája</span>
          </div>
          <pre className="text-xs bg-white dark:bg-gray-800 p-2 rounded border border-indigo-200 dark:border-indigo-700 overflow-x-auto">
{`{
  "contactPersons": [
    {
      "id": "cp123",
      "name": "Kiss János",
      "email": "janos@example.com",
      "phone": "+36301234567",
      "position": "Ügyvezető",
      "isPrimary": true
    }
  ],
  "count": 3
}`}
          </pre>
        </div>
      </div>

      <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-yellow-900 dark:text-yellow-100 mb-1">
          💡 Használat
        </h4>
        <p className="text-xs text-yellow-700 dark:text-yellow-300 mb-2">
          <strong>✨ Új:</strong> Közvetlenül köthető CRM Lekérdezés után - automatikusan kezeli a customers array-t!
        </p>
        <p className="text-xs text-yellow-700 dark:text-yellow-300">
          Kösd össze egy Loop node-dal, hogy minden kapcsolattartónak küldjél emailt vagy SMS-t.
        </p>
      </div>
    </div>
  );
};

export default GetContactPersonsConfig;
